module.exports = __webpack_public_path__ + "static/media/logo.093e8077.png";